import React from 'react';
import Slide from '@material-ui/core/Slide';

export default function Transition(props) {
  return <Slide direction="up" {...props} />;
}
